<form [formGroup]="addLandingZoneForm" (ngSubmit)="onSubmit()">
    <div class="dialog-header"> 
        <h2 class="dialog-title">Tenant Landing Zone Creation</h2>   
        <button class="cancel-button" mat-button type="button" [disabled]="isSubmitting()" (click)="onCancel()">Cancel</button>
    </div>
    <div class="dialog-body">
        <mat-dialog-content class="dialog-form">
            <div formArrayName="landingZone">
                @for (landingZoneInput of landingZoneInputs.controls; track landingZoneInput.get('id')?.value) {
                    <div class="landing-zone-form" [formGroupName]="$index"> 
                        <button class="delete-landing-zone-button" mat-stroked-button 
                            color="primary"
                            type="button" 
                            [disabled]="landingZoneInputs.length <= 1"
                            (click)="removeLandingZoneInput($index)"> 
                            <mat-icon class="delete-icon">delete</mat-icon>
                            Remove
                        </button>
                        <mat-form-field class="landing-zone-name-field">
                            <mat-label>Landing Zone Name</mat-label>
                            <input class="input" matInput formControlName="value">
                            @if (landingZoneInput.get('value')?.errors?.['required']) {
                                <mat-error>Landing zone name is required.</mat-error>
                            }
                            @if (landingZoneInput.get('value')?.errors?.['pattern']) {
                                <mat-error>Landing zone name must be 3-63 characters long and can only contain letters, numbers, and dashes.</mat-error>
                            }
                        </mat-form-field>
                    </div>
                }
            </div>
            @if (landingZoneInputs.hasError("notUnique") && landingZoneInputs.touched) {
                <mat-error>Landing zone names must be unique.</mat-error>
            }
            <button class="add-landing-zone-button" mat-stroked-button 
                color="primary"
                type="button" 
                [disabled]="landingZoneInputs.length >= 10"
                (click)="addLandingZone()"> 
                <mat-icon>add</mat-icon>
                Add Landing Zone
            </button>
        </mat-dialog-content>     
    </div>
    <mat-dialog-actions class="dialog-footer">
        <button class="submit-button" mat-flat-button 
            color="primary"
            type="submit" 
            [disabled]="!addLandingZoneForm.valid || isSubmitting()"> 
            @if (!isSubmitting()) {
                Create Landing Zone
            } @else {
                <div matSuffix class="submit-loading-spinner">
                    <app-loading-spinner [strokeWidth]="5"></app-loading-spinner>
                </div>
            }
        </button>
    </mat-dialog-actions>
</form>